__turbopack_context__.v({
  "scrollable": "Scrollable-module__NiJjra__scrollable",
  "scrollableMaskEnd": "Scrollable-module__NiJjra__scrollableMaskEnd",
  "scrollableMaskStart": "Scrollable-module__NiJjra__scrollableMaskStart",
  "scrollableWrapper": "Scrollable-module__NiJjra__scrollableWrapper",
  "visible": "Scrollable-module__NiJjra__visible",
});
